import React, { useState } from 'react';
import { Box, Typography, Grid } from '@mui/material';

const categories = [
  'Cloud',
  'DevOps',
  'AI/Data',
  'Programming',
  'Misc',
];

const TopCategories = ({ onCategorySelect }) => {
    const [selectedCategories, setSelectedCategories] = useState([]);

    const handleCategoryClick = (category) => {
        // Toggle selection of the clicked category
        if (selectedCategories.includes(category)) {
          const newSelection = selectedCategories.filter((c) => c !== category);
          setSelectedCategories(newSelection);
          onCategorySelect(newSelection);
        } else {
          const newSelection = [...selectedCategories, category];
          setSelectedCategories(newSelection);
          onCategorySelect(newSelection);
        }
      };

      return (
        <Box sx={{ mb: 4 , border:'1px solid #ddd',borderRadius: '8px',padding: '10px 20px',backgroundColor:'#ffffff' }} >
          <Typography variant="h6" color="primary"  gutterBottom>
            Select Categories: 
          </Typography>
          <Grid container spacing={2}>
            {categories.map((category) => (
              <Grid item key={category}>
                <Box
                  sx={{
                    padding: '10px 20px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    textAlign: 'center',
                    backgroundColor: selectedCategories.includes(category) ? 'primary.main' : '#f4f4f9',
                    color: selectedCategories.includes(category) ? '#ffffff' : '#212121',
                    border: selectedCategories.includes(category) ? 'none' : '1px solid #ddd',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      backgroundColor: selectedCategories.includes(category) ? 'primary.dark' : '#e0e0e0',
                    },
                  }}
                  onClick={() => handleCategoryClick(category)}
                >
                  <Typography variant="body1" fontWeight="bold">
                    {category}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      );
    };

export default TopCategories;
